import type { MarketType } from '@ps/isp-web-services-types';
import {
  allowedBetTrackingPlayerMarkets,
  allowedLinearBetTrackingPlayerMarkets,
  restrictedBetTrackingPlayerMarkets
} from '@ps/web-sports-enums';

export const getIsPlayerMarketAllowed = (marketType?: MarketType) =>
  marketType &&
  (allowedBetTrackingPlayerMarkets.includes(marketType) ||
    allowedLinearBetTrackingPlayerMarkets.includes(marketType));

export const getIsPlayerMarketRestricted = (marketType?: MarketType) =>
  marketType && restrictedBetTrackingPlayerMarkets.includes(marketType);

export const getIsPlayerMarketLinearProgress = (marketType?: MarketType) =>
  marketType && allowedLinearBetTrackingPlayerMarkets.includes(marketType);
